import { render, staticRenderFns } from "./tongueSquareS.vue?vue&type=template&id=52fd4e3a&"
import script from "./tongueSquareS.vue?vue&type=script&lang=js&"
export * from "./tongueSquareS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports